import type { NavPalette } from "./nav-palette";

import { nav as v1Nav } from "@/components/variations/v1/landing/palette";
import { nav as v2Nav } from "@/components/variations/v2/landing/palette";
import { nav as v3Nav } from "@/components/variations/v3/landing/palette";
import { nav as v4Nav } from "@/components/variations/v4/landing/palette";
import { nav as v5Nav } from "@/components/variations/v5/landing/palette";
import { nav as v6Nav } from "@/components/variations/v6/landing/palette";
import { nav as v7Nav } from "@/components/variations/v7/landing/palette";
import { nav as v8Nav } from "@/components/variations/v8/landing/palette";
import { nav as v9Nav } from "@/components/variations/v9/landing/palette";

export const navPalettes: Record<string, NavPalette> = {
  v1: v1Nav,
  v2: v2Nav,
  v3: v3Nav,
  v4: v4Nav,
  v5: v5Nav,
  v6: v6Nav,
  v7: v7Nav,
  v8: v8Nav,
  v9: v9Nav,
};

export function getNavPalette(slug: string): NavPalette {
  return navPalettes[slug] ?? v1Nav;
}
